export const TOTAL_CONVERSIONS_RANGE_ALL = 'all';
export const TOTAL_CONVERSIONS_RANGE_WEEK = 'week';
export const TOTAL_CONVERSIONS_RANGE_MONTH = 'month';
export const TOTAL_CONVERSIONS_RANGES = [
    TOTAL_CONVERSIONS_RANGE_WEEK,
    TOTAL_CONVERSIONS_RANGE_MONTH,
    TOTAL_CONVERSIONS_RANGE_ALL
];
export const TOTAL_CONVERSIONS_RANGE_LABELS = {
    [TOTAL_CONVERSIONS_RANGE_ALL]: 'All',
    [TOTAL_CONVERSIONS_RANGE_WEEK]: '1W',
    [TOTAL_CONVERSIONS_RANGE_MONTH]: '1M'
};
export const TIME_SERIES_UNIT_DAY = 'day';
export const TIME_SERIES_UNIT_WEEK = 'week';
export const TIME_SERIES_UNIT_MONTH = 'month';
export const TIME_SERIES_UNIT_QUARTER = 'quarter';
export const TIME_SERIES_UNIT_YEAR = 'year';
